import { WatchQueryFetchPolicy } from '@apollo/client'

import { useLazyFetchStats } from 'modules/shift_management/components/ShiftManagement/MainPage/useFetchStats'
import { useSchedule } from 'modules/shift_management/hooks/useSchedule'
import { useShiftsRows } from 'modules/shift_management/hooks/useShiftsRows'
import { useUI } from 'modules/shift_management/hooks/useUI'
import type { ShiftsRow } from 'modules/shift_management/lib/types'

const useRefreshStats = ({}: {
  fetchPolicy?: WatchQueryFetchPolicy
} = {}) => {
  const [, dispatchShiftsRows] = useShiftsRows()
  const [, dispatchSchedule] = useSchedule()
  const [, dispatchUI] = useUI()
  const { refetchData } = useLazyFetchStats()

  const refreshStats = async (shiftsRows: ShiftsRow[]) => {
    const { stats } = await refetchData()
    dispatchShiftsRows({
      type: 'REFRESH_SHIFTS_ROWS',
      shiftsRows: [],
      affectedEmployeeIds: [],
    })
    dispatchUI({ type: 'NOT_REFRESHING_STATS' })
    dispatchSchedule({
      type: 'REFRESH_STATS',
      previousShiftsRows: shiftsRows,
      shiftsRows: [],
      stats: {
        hasDrafts: stats.hasDrafts,
        hasDraftsWithoutConflict: stats.hasDraftsWithoutConflict,
        shiftConflicts: stats.shiftConflicts,
      },
    })
  }

  return { refreshStats }
}

export { useRefreshStats }
